module.exports = __webpack_public_path__ + "img/new-m-afpi.e295455b.png";